var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1962 2.33417L2.39625 13.1341C1.15828 14.372 1.15828 16.3792 2.39625 17.6172C3.63423 18.8551 5.64138 18.8551 6.87935 17.6172L17.6792 6.81727C18.3956 6.10087 18.3956 4.93937 17.6792 4.22298L15.7904 2.33417C15.074 1.61778 13.9125 1.61778 13.1962 2.33417ZM11.2845 6.60287L14.3747 3.51268C14.4402 3.44716 14.5464 3.44716 14.6119 3.51268L16.5007 5.4015C16.5663 5.46701 16.5663 5.57324 16.5007 5.63875L13.4105 8.72895L11.2845 6.60287ZM10.106 7.78138L3.57477 14.3126C2.98767 14.8997 2.98766 15.8516 3.57476 16.4387C4.16186 17.0258 5.11374 17.0258 5.70084 16.4387L12.232 9.90746L10.106 7.78138Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.3021165c8f0e1134643b384b5e961087.svg";
export { ForwardRef as ReactComponent };